<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft bg-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">PRAHARI Login</h5>
                  <p>Advance Driver Advisory System</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link to="/">
                <div class="avatar-md profile-user-wid">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/logo.png" alt height="73" />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >
            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                class="mb-3"
                id="username-inp-group"
                label="Username"
                label-for="username-inp"
              >
                <b-form-input
                  id="username-inp"
                  v-model="username"
                  type="text"
                  placeholder="Enter Username"
                  :class="{ 'is-invalid': submitted && $v.username.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.username.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.username.required"
                    >Username is required.</span
                  >
                </div>
              </b-form-group>

              <b-form-group
                class="mb-3"
                id="password-inp-group"
                label="Password"
                label-for="password-inp"
              >
                <b-form-input
                  id="password-inp"
                  v-model="password"
                  type="password"
                  placeholder="Enter password"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Password is required.
                </div>
              </b-form-group>
              <Loader class="mt-4">
                <div class="d-grid">
                  <b-button type="submit" variant="primary" class="btn-block">
                    Log In
                  </b-button>
                </div>
              </Loader>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<script>
import Layout from "@/layouts/auth";
import { authMethods, notificationMethods } from "@/state/helpers";
import { mapState, mapActions } from "vuex";
import Loader from "@/components/widgets/loader.vue";
import appConfig from "@/app.config";
import { required } from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Loader,
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
      authError: null,
      isAuthError: false,
    };
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("auth", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  mounted() {
    this.changeLoaderValue(false);
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    ...mapActions("layout", ["changeLoaderValue"]),

    async tryToLogIn() {
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const { username, password } = this;
        if (username && password) {
          this.changeLoaderValue(true);
          await this.login({
            username,
            password,
          });

          this.$router.push("/tablet/dashboard");

          this.submitted = false;
          this.changeLoaderValue(false);
        }
      }
    },
  },
};
</script>
